import {
  sessionUrlParamsMetadataFields,
  urlParamsMetadataFields,
} from '~/javascripts/utils/params';

export default () => ({
  urlParamsMetadataFields: JSON.stringify(urlParamsMetadataFields()),
  sessionUrlParamsMetadataFields: JSON.stringify(
    sessionUrlParamsMetadataFields()
  ),
});
